"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTagPadding = void 0;

var _designLanguage = require("@doordash/design-language");

var _TagTypes = require("./types/TagTypes");

var _constants = require("./constants");

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getTagPadding = function getTagPadding(props) {
  var shapePaddingVals = _constants.shapePadding[props.theme.Shape.TagDefault] || _constants.shapePadding[_designLanguage.Shape.Rectangle];
  var paddingVals = shapePaddingVals[props.size] || shapePaddingVals[_TagTypes.TagSizes.Small];
  var verticalPadding = props.hasLeadingIcon || props.hasTrailingIcon ? paddingVals.verticalWithIcon : paddingVals.vertical;
  return "".concat(verticalPadding, "px ").concat(props.hasTrailingIcon ? paddingVals.horizontalWithIcon : paddingVals.horizontal, "px ").concat(verticalPadding, "px ").concat(props.hasLeadingIcon ? paddingVals.horizontalWithIcon : paddingVals.horizontal, "px");
};

exports.getTagPadding = getTagPadding;